import { node, number, oneOf, string, func } from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import styles from './Space.less';

const Space = ({ children, size, direction, justify, onClick, className, ...rest }) => {
  return (
    <div
      className={classNames([styles.container, className])}
      onClick={onClick}
      style={{
        columnGap: size,
        rowGap: size,
        justifyContent: justify,
        flexDirection: direction === 'horizontal' ? 'row' : 'column',
        ...rest,
      }}>
      {children}
    </div>
  );
};

export default Space;

Space.defaultProps = {
  children: null,
  size: 16,
  direction: 'vertical',
  justify: 'flex-start',
  onClick: () => null,
  className: '',
};

Space.propTypes = {
  children: node,
  size: number,
  justify: string,
  onClick: func,
  className: string,
  direction: oneOf(['vertical', 'horizontal']),
};
